import { formatInteger, formatUsd } from '../../demo/format'
import { useMonitorKpis } from '../../demo/selectors'
import { Icon, KpiCard } from '../../ui'
import styles from './KpiRow.module.css'

export function KpiRow() {
  const kpis = useMonitorKpis()
  const items = [
    { key: 'running', icon: 'play' as const, label: '投放中广告', value: formatInteger(kpis.running) },
    { key: 'spend', icon: 'dollar' as const, label: '本月花费', value: formatUsd(kpis.spendMonth) },
    { key: 'orders', icon: 'clipboard' as const, label: '转化订单', value: formatInteger(kpis.orders) },
    { key: 'reach', icon: 'trend' as const, label: '商品曝光量', value: formatInteger(kpis.reach) },
  ]

  return (
    <div className={styles.row} data-scope="monitor-kpi-row">
      {items.map((item) => (
        <KpiCard key={item.key} icon={<Icon name={item.icon} size={22} />} label={item.label} value={item.value} />
      ))}
    </div>
  )
}
